import axios from 'axios'

export default {
    get: () => axios.get('zones'),
    store: (data) => axios.post('zones/store', data),
    update: (data) => axios.post('zones/update', data),
    delete: (id) => axios.post('zones/delete', id)
}